export enum MapScreenType {
  Parcs = 'Parcs',
  ParcDetail = 'ParcDetail',
  Exutoires = 'Exutoires',
  Transporteurs = 'Transporteurs'
}